import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface PurchaseRequestModel {
    id: number
    user_pin: string
    name: string
}

export interface RejectModel {
    purchase_request_id: number
    proof_of_rejection: string
    remarks: string
}

export interface MarkPurchasedModel {
    purchase_request_id: number
    proof_of_purchase: string
    transfer_balance_amount_to_wallet: number
    final_amount: number
}

export interface CollectedStatusState {
    purchase_request_id: number
    remarks: string
}

export interface ChangeInvoiceState {
    purchase_request_id: number
    attachment: string
    is_invoice: number
}

export interface UpdateShipmentState {
    purchase_request_id: number
    shipment_number: string
}

const purchaseRequestApi = (apiInstance: AxiosInstance) => {
    const purchaseRequestList = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/RequestOperationsController/getAllRequests`)
        return res
    }

    const rejectReasonsList = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/RequestOperationsController/getAllReasons`)
        return res
    }
    const purchaseRequestReject = async (rejectData: RejectModel): Promise<any> => {
        const rejectPurchaseRequest = apiInstance.post(
            "/RequestOperationsController/rejectPurchaseRequest",
            rejectData
        )
        return rejectPurchaseRequest
    }

    const markAsPurchased = async (rejectData: MarkPurchasedModel): Promise<any> => {
        const loggedInUserInfo = apiInstance.post("/RequestOperationsController/markAsPurchased", rejectData)
        return loggedInUserInfo
    }

    const changeStatusCollected = async (data: CollectedStatusState): Promise<any> => {
        const changeStatusRequest = apiInstance.post("/PurchaseRequestController/collectedRequestRemarks", data)
        return changeStatusRequest
    }

    const changeInvoice = async (data: ChangeInvoiceState): Promise<any> => {
        const changeStatusRequest = apiInstance.post(
            "/RequestOperationsController/requestAttachmentUpload",
            data
        )
        return changeStatusRequest
    }

    const requestToDeductFromWallet = async (rejectData: RejectModel): Promise<any> => {
        const rejectPurchaseRequest = apiInstance.post(
            "/PurchaseRequestController/RequestDeductFromWallet",
            rejectData
        )
        return rejectPurchaseRequest
    }

    const updateShipmentNumber = async (data: UpdateShipmentState): Promise<any> => {
        const shipmentRequest = apiInstance.post("/RequestOperationsController/updateShipmentNumber", data)
        return shipmentRequest
    }

    return {
        purchaseRequestList,
        rejectReasonsList,
        purchaseRequestReject,
        markAsPurchased,
        changeStatusCollected,
        changeInvoice,
        requestToDeductFromWallet,
        updateShipmentNumber
    }
}

export default purchaseRequestApi
